<template>
  <div
    class="slide-sidebar"
    :class="`slide-sidebar--${slideDirection} slide-sidebar--size-${slideSize}`"
  >
    <transition name="fade">
      <div
        class="slide-sidebar__curtains"
        v-if="isSlideSidebarVisible"
      ></div>
    </transition>

    <div v-click-outside="hide">
      <transition name="slide">
        <component
          v-if="loadedComponents[slideSidebarCurrentSlot]"
          :is="loadedComponents[slideSidebarCurrentSlot]"
          :key="slideSidebarCurrentSlot"
          v-bind="slideProps"
        />
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ClickOutside from 'vue-click-outside'

  export default {
    directives: {
      ClickOutside,
    },

    data: () => ({
      loadedComponents: {}
    }),

    mounted () {
      window.onhashchange = () => {
        const sidebar = window.location.hash.split('-').pop()
        if (sidebar) {
          const index = this.slideQueue.findIndex(i => i.name === sidebar)
          const length = this.slideQueue.length

          if (index == length - 1) {
            return null
          }

          this.slideSidebarBack();
        }
      }
    },

    computed: {
      ...mapGetters('slideSidebar', [
        'isSlideSidebarVisible',
        'slideSidebarCurrentSlot',
        'slideDirection',
        'slideSize',
        'slideProps',
        'slideQueue'
      ]),
    },

    watch: {
      $route(newState, oldState) {
        if (newState.hash == '' || newState.hash == oldState.hash) {
          this.slideSidebarHide()
        }
      },

      slideSidebarCurrentSlot (newState) {
        if (newState) this.loadComponent()
      },

      isSlideSidebarVisible (isVisible) {
        document.body.style.overflow = isVisible ? 'hidden' : 'auto'
      }
    },

    methods: {
      ...mapActions('slideSidebar', [
          'slideSidebarHide',
          'slideSidebarBack', 
          'slideSidebarShow'
        ]),

      hide () {
        if (this.slideSidebarCurrentSlot) {
          this.slideSidebarHide()
        }
      },

      loadComponent () {
        if (typeof this.loadComponent[this.slideSidebarCurrentSlot] === 'undefined') {
          this.loadedComponents[this.slideSidebarCurrentSlot] = () => import(`@/components/layout/sidebars/sidebars/${this.slideSidebarCurrentSlot}.vue`)
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .slide-sidebar {
    $p: &;

    &__curtains {
      position: fixed;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(#000, .6);
      z-index: 1000;
    }

    .slide-enter-active, .slide-leave-active { transition: transform .5s }
    .slide-enter, .slide-leave-to { transform: translateX(100%) }

    .fade-enter-active, .fade-leave-active { transition: opacity .5s }
    .fade-enter, .fade-leave-to { opacity: 0 }

    &--left {
      .slide-enter, .slide-leave-to { transform: translateX(-100%) }

      /deep/ .slide-sidebar-container__container {
        right: auto;
        left: 0;
        box-shadow: 1px 0 10px 0px rgba(#000, .05);
      }

      /deep/ .slide-sidebar-container__header-content {
        display: inline-block;
      }
    }

    &--size-full {
      /deep/ .slide-sidebar-container__container {
        width: 80%;
      }
    }
  }
</style>